<template>
    <ed-layout>
        <router-view />
    </ed-layout>
</template>

<script>
    export default {
        data() {
            return {}
        },
    }
</script>

<style lang="scss" scoped></style>
